import { css, theme } from '@kui-shared/styles';

const ButtonStyle = css({
  // Reset
  cursor: 'pointer',
  // Colors
  border: `1px solid ${theme.colors.g500}`,
  // Layout
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.space.xs,
  // Standard
  fontSize: theme.fontSizes.ms,
  fontWeight: theme.fontWeights.medium,
  fontFamily: theme.fonts.nvidiaSans,
  lineHeight: theme.lineHeights.text,
  padding: `${theme.space.sm} ${theme.space.ms}`,
  // Disabled State
  '&:disabled:hover': {
    cursor: 'not-allowed'
  },
  variants: {
    size: {
      large: {
        fontSize: theme.fontSizes.md,
        padding: theme.space.ms
      },
      small: {
        fontSize: theme.fontSizes.sm,
        padding: theme.space.ss
      },
      standard: {
        fontSize: theme.fontSizes.ms,
        padding: theme.space.sm
      },
      tiny: {
        fontSize: theme.fontSizes.sm,
        padding: theme.space.xs
      }
    },
    tone: {
      primary: {
        backgroundColor: theme.colors.actionBgPrimary,
        borderColor: theme.colors.actionBorderPrimary,
        color: theme.colors.actionFgPrimary,
        '&:hover': {
          backgroundColor: theme.colors.actionBgPrimaryHover,
          borderColor: theme.colors.actionBorderPrimaryHover,
          color: theme.colors.actionFgPrimaryHover
        },
        '&:active': {
          backgroundColor: theme.colors.actionBgPrimaryActive,
          borderColor: theme.colors.actionBorderPrimaryActive,
          color: theme.colors.actionFgPrimaryActive
        },
        '&:disabled': {
          backgroundColor: theme.colors.actionBgPrimaryDisabled,
          borderColor: theme.colors.actionBorderPrimaryDisabled,
          color: theme.colors.actionFgPrimaryDisabled
        }
      },
      secondary: {
        backgroundColor: theme.colors.actionBgSecondary,
        borderColor: theme.colors.actionBorderSecondary,
        color: theme.colors.actionFgSecondary,
        '&:hover': {
          backgroundColor: theme.colors.actionBgSecondaryHover,
          borderColor: theme.colors.actionBorderSecondaryHover,
          color: theme.colors.actionFgSecondaryHover
        },
        '&:active': {
          backgroundColor: theme.colors.actionBgSecondaryActive,
          borderColor: theme.colors.actionBorderSecondaryActive,
          color: theme.colors.actionFgSecondaryActive
        },
        '&:disabled': {
          backgroundColor: theme.colors.actionBgSecondaryDisabled,
          borderColor: theme.colors.actionBorderSecondaryDisabled,
          color: theme.colors.actionFgSecondaryDisabled
        }
      },
      tertiary: {
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        color: theme.colors.actionFgTertiary,
        '&:hover': {
          backgroundColor: theme.colors.actionBgTertiaryHover,
          borderColor: 'transparent',
          color: theme.colors.actionFgTertiaryHover
        },
        '&:active': {
          backgroundColor: theme.colors.actionBgTertiaryActive,
          borderColor: 'transparent',
          color: theme.colors.actionFgTertiaryActive
        },
        '&:disabled': {
          backgroundColor: 'transparent',
          borderColor: 'transparent',
          color: theme.colors.actionFgTertiaryDisabled
        }
      }
    },
    danger: {
      true: {
        backgroundColor: theme.colors.actionBgPrimaryDanger,
        borderColor: theme.colors.actionBorderPrimaryDanger,
        color: theme.colors.actionFgPrimaryDanger,
        '&:hover:not(:disabled)': {
          backgroundColor: theme.colors.actionBgPrimaryDangerHover,
          borderColor: theme.colors.actionBorderPrimaryDangerHover
        },
        '&:active:not(:disabled)': {
          backgroundColor: theme.colors.actionBgPrimaryDangerActive,
          borderColor: theme.colors.actionBorderPrimaryDangerActive
        }
      }
    }
  },
  compoundVariants: [{
    tone: 'secondary',
    danger: true,
    css: {
      backgroundColor: theme.colors.actionBgSecondaryDanger,
      borderColor: theme.colors.actionBorderSecondaryDanger,
      color: theme.colors.actionFgSecondaryDanger,
      '&:hover:not(:disabled)': {
        backgroundColor: theme.colors.actionBgSecondaryDangerHover,
        borderColor: theme.colors.actionBorderSecondaryDangerHover,
        color: theme.colors.actionFgSecondaryDangerHover
      },
      '&:active:not(:disabled)': {
        backgroundColor: theme.colors.actionBgSecondaryDangerActive,
        borderColor: theme.colors.actionBorderSecondaryDangerActive,
        color: theme.colors.actionFgSecondaryDangerActive
      }
    }
  }, {
    tone: 'tertiary',
    danger: true,
    css: {
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      color: theme.colors.actionFgTertiaryDanger,
      '&:hover:not(:disabled)': {
        backgroundColor: theme.colors.actionBgTertiaryDangerHover,
        borderColor: 'transparent',
        color: theme.colors.actionFgTertiaryDanger
      },
      '&:active:not(:disabled)': {
        backgroundColor: theme.colors.actionBgTertiaryDangerActive,
        borderColor: 'transparent',
        color: theme.colors.actionFgTertiaryDangerActive
      }
    }
  }]
});

/**
 * TestIDs
 */
const ButtonTestIDs = {
  Button: 'kui-button'
};
/**
 * Defaults
 */
const ButtonDefaults = {
  css: {},
  danger: false,
  size: 'standard',
  tone: 'primary'
};

const ButtonSizes = ['large', 'small', 'standard', 'tiny'];
const ButtonTones = ['primary', 'secondary', 'tertiary'];

export { ButtonDefaults, ButtonSizes, ButtonStyle, ButtonTestIDs, ButtonTones };
